import { render, staticRenderFns } from "./AddContentBox.vue?vue&type=template&id=2fc9b71c&"
import script from "./AddContentBox.vue?vue&type=script&lang=js&"
export * from "./AddContentBox.vue?vue&type=script&lang=js&"
import style0 from "./AddContentBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports